import React from "react";
import IphoneMockup from "../../../landingPage/pages/Homepage/assets/iphone-mockup-2_1.png";
import SquaberLogo from "../../../landingPage/pages/Homepage/assets/squaber-logo.svg";

function AuthPageHero() {
  return (
    <div className={"bg-header rounded-3xl flex flex-col p-6"}>
      <img
        src={SquaberLogo}
        alt={"Squaber"}
        height={40}
        className={"ml-auto mb-6"}
      />
      <div className={"h-full flex flex-col align-center justify-center"}>
        <img
          src={IphoneMockup}
          alt={"Squaber app"}
          height={500}
          className={"mb-20"}
        />
        <div className={"text-center max-w-500"}>
          <strong
            className={
              "font-medium text-medium text-3xl.2 line-height-120 text-white mb-4 block"
            }
          >
            Zaawansowane <span className={"text-yellow"}>narzędzie</span>
            <br />
            dla inwestorów
          </strong>
          <p className={"text-sm line-height-130 text-white opacity-70"}>
            Twórz portfele akcyjne. Wybieraj spółki na bazie sygnałów giełdowych
            i formacji wzrostowych. Wykorzystuj strefy popytu i alerty
            inwestycyjne.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AuthPageHero;
